/* marquee  */
(function(factory){"use strict";if(typeof define==="function"&&define.amd){define(["jquery"],factory)}else if(typeof exports!=="undefined"){module.exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){$.fn.marquee=function(options){return this.each(function(){var o=$.extend({},$.fn.marquee.defaults,options),$this=$(this),$marqueeWrapper,containerWidth,animationCss,verticalDir,elWidth,loopCount=3,playState="animation-play-state",css3AnimationIsSupported=false,_prefixedEvent=function(element,type,callback){var pfx=["webkit","moz","MS","o",""];for(var p=0;p<pfx.length;p++){if(!pfx[p])type=type.toLowerCase();element.addEventListener(pfx[p]+type,callback,false)}},_objToString=function(obj){var tabjson=[];for(var p in obj){if(obj.hasOwnProperty(p)){tabjson.push(p+":"+obj[p])}}tabjson.push();return"{"+tabjson.join(",")+"}"},_startAnimationWithDelay=function(){$this.timer=setTimeout(animate,o.delayBeforeStart)},methods={pause:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"paused")}else{if($.fn.pause){$marqueeWrapper.pause()}}$this.data("runningStatus","paused");$this.trigger("paused")},resume:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"running")}else{if($.fn.resume){$marqueeWrapper.resume()}}$this.data("runningStatus","resumed");$this.trigger("resumed")},toggle:function(){methods[$this.data("runningStatus")==="resumed"?"pause":"resume"]()},destroy:function(){clearTimeout($this.timer);$this.find("*").addBack().off();$this.html($this.find(".js-marquee:first").html())}};if(typeof options==="string"){if($.isFunction(methods[options])){if(!$marqueeWrapper){$marqueeWrapper=$this.find(".js-marquee-wrapper")}if($this.data("css3AnimationIsSupported")===true){css3AnimationIsSupported=true}methods[options]()}return}var dataAttributes={},attr;$.each(o,function(key){attr=$this.attr("data-"+key);if(typeof attr!=="undefined"){switch(attr){case"true":attr=true;break;case"false":attr=false;break}o[key]=attr}});if(o.speed){o.duration=parseInt($this.width(),10)/o.speed*1e3}verticalDir=o.direction==="up"||o.direction==="down";o.gap=o.duplicated?parseInt(o.gap):0;$this.wrapInner('<div class="js-marquee"></div>');var $el=$this.find(".js-marquee").css({"margin-right":o.gap,float:"left"});if(o.duplicated){$el.clone(true).appendTo($this)}$this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');$marqueeWrapper=$this.find(".js-marquee-wrapper");if(verticalDir){var containerHeight=$this.height();$marqueeWrapper.removeAttr("style");$this.height(containerHeight);$this.find(".js-marquee").css({float:"none","margin-bottom":o.gap,"margin-right":0});if(o.duplicated){$this.find(".js-marquee:last").css({"margin-bottom":0})}var elHeight=$this.find(".js-marquee:first").height()+o.gap;if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration;o.duration=parseInt(elHeight,10)/parseInt(containerHeight,10)*o.duration}else{o.duration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration}}else{elWidth=$this.find(".js-marquee:first").width()+o.gap;containerWidth=$this.width();if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration;o.duration=parseInt(elWidth,10)/parseInt(containerWidth,10)*o.duration}else{o.duration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration}}if(o.duplicated){o.duration=o.duration/2}if(o.allowCss3Support){var elm=document.body||document.createElement("div"),animationName="marqueeAnimation-"+Math.floor(Math.random()*1e7),domPrefixes="Webkit Moz O ms Khtml".split(" "),animationString="animation",animationCss3Str="",keyframeString="";if(elm.style.animation!==undefined){keyframeString="@keyframes "+animationName+" ";css3AnimationIsSupported=true}if(css3AnimationIsSupported===false){for(var i=0;i<domPrefixes.length;i++){if(elm.style[domPrefixes[i]+"AnimationName"]!==undefined){var prefix="-"+domPrefixes[i].toLowerCase()+"-";animationString=prefix+animationString;playState=prefix+playState;keyframeString="@"+prefix+"keyframes "+animationName+" ";css3AnimationIsSupported=true;break}}}if(css3AnimationIsSupported){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s infinite "+o.css3easing;$this.data("css3AnimationIsSupported",true)}}var _rePositionVertically=function(){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+elHeight+"px")+")")},_rePositionHorizontally=function(){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+elWidth+"px")+")")};if(o.duplicated){if(verticalDir){if(o.startVisible){$marqueeWrapper.css("transform","translateY(0)")}else{$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+(elHeight*2-o.gap)+"px")+")")}}else{if(o.startVisible){$marqueeWrapper.css("transform","translateX(0)")}else{$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+(elWidth*2-o.gap)+"px")+")")}}if(!o.startVisible){loopCount=1}}else if(o.startVisible){loopCount=2}else{if(verticalDir){_rePositionVertically()}else{_rePositionHorizontally()}}var animate=function(){if(o.duplicated){if(loopCount===1){o._originalDuration=o.duration;if(verticalDir){o.duration=o.direction==="up"?o.duration+containerHeight/(elHeight/o.duration):o.duration*2}else{o.duration=o.direction==="left"?o.duration+containerWidth/(elWidth/o.duration):o.duration*2}if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}loopCount++}else if(loopCount===2){o.duration=o._originalDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}loopCount++}}if(verticalDir){if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?0:"-"+elHeight+"px")+")")}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":containerHeight+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionVertically()}}else{_rePositionVertically();animationCss={transform:"translateY("+(o.direction==="up"?"-"+$marqueeWrapper.height()+"px":containerHeight+"px")+")"}}}else{if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?0:"-"+elWidth+"px")+")")}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionHorizontally()}}else{_rePositionHorizontally();animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"}}}$this.trigger("beforeStarting");if(css3AnimationIsSupported){$marqueeWrapper.css(animationString,animationCss3Str);var keyframeCss=keyframeString+" { 100%  "+_objToString(animationCss)+"}",$styles=$marqueeWrapper.find("style");if($styles.length!==0){$styles.filter(":last").html(keyframeCss)}else{$("head").append("<style>"+keyframeCss+"</style>")}_prefixedEvent($marqueeWrapper[0],"AnimationIteration",function(){$this.trigger("finished")});_prefixedEvent($marqueeWrapper[0],"AnimationEnd",function(){animate();$this.trigger("finished")})}else{$marqueeWrapper.animate(animationCss,o.duration,o.easing,function(){$this.trigger("finished");if(o.pauseOnCycle){_startAnimationWithDelay()}else{animate()}})}$this.data("runningStatus","resumed")};$this.on("pause",methods.pause);$this.on("resume",methods.resume);if(o.pauseOnHover){$this.on("mouseenter",methods.pause);$this.on("mouseleave",methods.resume)}if(css3AnimationIsSupported&&o.allowCss3Support){animate()}else{_startAnimationWithDelay()}})};$.fn.marquee.defaults={allowCss3Support:true,css3easing:"linear",easing:"linear",delayBeforeStart:1e3,direction:"left",duplicated:false,duration:5e3,speed:0,gap:20,pauseOnCycle:false,pauseOnHover:false,startVisible:false}});

document.querySelectorAll('.Collection_custom_details_block_innerloops_innerblock_new a').forEach(btn => {
   btn.addEventListener('click', () => {
      document.querySelectorAll('.Collection_custom_details_block_innerloops_innerblock_new a').forEach(btn => {
          btn.classList.remove('active');
        })
      btn.classList.add('active')
   })
})

function allSiteMarquee() {
  var widthMarquee = $(window).width();
  if(widthMarquee < 750)
  {
    $('.Index_information_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_information_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }


  if(widthMarquee < 750)
  {
    $('.Index_custom_logo_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_custom_logo_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }


  if(widthMarquee < 750)
  {
    $('.Index_object_instagram_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_object_instagram_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }

  $('.Index_object_testimonial_rightside_marquee').marquee({
    duration: 55000,
    gap: 0,
    delayBeforeStart: 0,
    direction: 'right',
    duplicated: true,
    startVisible: true
  });

  $('.Index_object_testimonial_leftside_marquee').marquee({
    duration: 55000,
    gap: 0,
    delayBeforeStart: 0,
    direction: 'left',
    duplicated: true,
    startVisible: true
  });

  $('.Index_object_testimonial_mobile_marquee').marquee({
    duration: 20000,
    gap: 0,
    delayBeforeStart: 0,
    direction: 'left',
    duplicated: true,
    startVisible: true
  });

  if(widthMarquee < 750)
  {
    $('.Index_tab_feature_collect_block_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_tab_feature_collect_block_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
}
allSiteMarquee()

$(".Tabs_common_inner_new").click(function() {
    var tab_id = $(this).attr("tab_id");
    if ($(this).hasClass("active") == false) {
        $(this).parents(".Tabs_common_main_new").find(".Tabs_common_inner_new").removeClass("active");
        $(this).parents(".Tabs_common_main_new").find(".tabcontent").css("display", "none");

        $(this).addClass("active");
        $(this).parents(".Tabs_common_main_new").find("." + tab_id + "_open").css("display", "block");
    }
})

$(".Tabs_common_inner_hover_new").hover(function() {
    var tab_id = $(this).attr("tab_id");
    if ($(this).hasClass("active") == false) {
        $(this).parents(".Tabs_common_main_new").find(".Tabs_common_inner_hover_new").removeClass("active");
        $(this).parents(".Tabs_common_main_new").find(".tabcontent").css("display", "none");

        $(this).addClass("active");
        $(this).parents(".Tabs_common_main_new").find("." + tab_id + "_open").css("display", "block");
    }
})

function initAccordion() {
    $(".accordion .question").click(function() {
        if ($(this).parent("li").hasClass("open") == false) {
            $(this).parents(".accordion").find(".answer").slideUp();
            $(this).parents(".accordion").find("li").removeClass("open");

            $(this).next(".answer").slideDown();
            $(this).parent(".accordion li").addClass("open");
        } else {
            $(this).parents(".accordion").find(".answer").slideUp();
            //$(this).parents(".accordion").find(".answer").css("display", "none");
            $(this).parents(".accordion").find("li").removeClass("open");
        }
    })
}
initAccordion();

$('.footer-block__details-content .list-unstyled a').on('click', function(event) {
    var target = $(this).attr('href');
    var hash = target.substring(target.indexOf('#') + 1);
    if (hash) {
        $('html, body').stop().animate({
            scrollTop: $("#" + hash).offset().top - 200
        }, 500);

        if ($("#" + hash).hasClass("open") == false) {
            setTimeout(function() {
                $("#" + hash + " .question").trigger("click");
            }, 700)
        }
    }
});

function play_video_on_hover(){
  $(".play_video_on_hover").hover(function(){
    var URL = $(this).find('video').attr("video_url");
    if(!$(this).find('video').attr("src")){
      $(this).find('video').attr("src",URL);  
    }
    $(this).find('video').trigger('play');
  }, function() {
    $(this).find('video').trigger('pause');
  })
}
play_video_on_hover()


function mobileMenuHeight() {
  var announcementBarHeight = $(".Header_announcement_bar_main_new").outerHeight(true) || 0;
  //var headerHeight = $(".header-section").outerHeight(true) || 76;
  var headerHeight = 76;
  var totalHeight = announcementBarHeight + headerHeight;
  $(".menu-drawer").css("top", totalHeight + "px");
  $(".menu-drawer__backdrop").css("top", totalHeight + "px");
  $(".menu-drawer").css("height", "calc(100% - "+(totalHeight + 22)+"px)");
  
  var totalHeightUp = headerHeight - 1;

  $("[data-scroll-direction=up] .menu-drawer").css("top", totalHeightUp + "px");
  $("[data-scroll-direction=up] .menu-drawer__backdrop").css("top", totalHeightUp + "px");
  $("[data-scroll-direction=up] .menu-drawer").css("height", "calc(100% - "+ (totalHeightUp + 22) +"px)");
  
}
mobileMenuHeight();

$(".header__icon--menu").click(function () {
  mobileMenuHeight();
});
// Recalculate on resize
$(window).on("resize", mobileMenuHeight);


function sliderHeight() {
  var announcementBarHeight_S = $(".Header_announcement_bar_main_new").outerHeight(true) || 0;
  var windowHeight_s = $(window).height();
  var windowwidth_s = $(window).width();
  var headerHeight_s = 76;
  var totalHeight_s = windowHeight_s - announcementBarHeight_S - 3;
  if(windowwidth_s < 750) {
    $(".Index_custom_slideshows_innerloops_innerblock_innermedia_new").css("padding-bottom", totalHeight_s + "px");
  }
  else if(windowwidth_s > 1900) {
    $(".Index_custom_slideshows_innerloops_innerblock_innermedia_new").css("padding-bottom", totalHeight_s + "px");
  }
  else{
    $(".Index_custom_slideshows_innerloops_innerblock_innermedia_new").css("padding-bottom", "");
  }
}
sliderHeight();
$(window).on("resize", sliderHeight);


function initVideoClick() {
  $(".play_icon_new").click(function(){
    if($(this).hasClass("active") == false)
    {
      $(this).parents(".video_play_list_new").find(".play_icon_new").removeClass("active");
      $(this).parents(".video_play_list_new").find('video').trigger('pause');
      $(this).parents(".video_play_list_new").find(".play_icon").css("display","block");
      //$(this).parents(".video_play_list_new").find(".mute_video_main_new").removeClass("active");
      //$(this).parents(".video_play_list_new").find(".mute_video").addClass("active");
      //$(this).parents(".video_play_list_new").find(".unmute_video").removeClass("active");
      //$(this).parents(".video_play_list_new").find("video").prop("muted",0)
      
      $(this).addClass("active");
      var URL = $(this).find('video').attr("video_url");
      if($(this).find('video').attr("src") == null)
      {
        $(this).find('video').attr("src",URL);
      }
      $(this).find('video').trigger('play');
      $(this).siblings().find('video').trigger('pause');
      $(this).siblings().find('.play_icon').css("display","block");
      $(this).find(".play_icon").css("display","none");
      //$(this).parents(".video_main_block").find(".mute_video_main_new").addClass("active");
    }
    else
    {
      $(this).removeClass("active");
      $(this).find('video').trigger('pause');
      $(this).find(".play_icon").css("display","block");
      //$(this).parents(".video_play_list").find(".mute_video_main_new").removeClass("active");
    }
  })
}
initVideoClick();

function productPageScript(){

  /* Retailers Popup */
  $(".Product_retailers_drawer_inner_new").click(function () {
    $('body').addClass("overflow-hidden");
    $('body').addClass("Product_retailers_drawer_open_new");
    $(".Product_retailers_drawer_overlay_new").addClass("open");
    $(".Product_retailers_drawer_maindetail_new").addClass("open");
  })
  $(".Product_retailers_drawer_overlay_new, .Product_retailers_drawer_innerdetail_innerside_innerclose_new").click(function () {
    $('body').removeClass("overflow-hidden");
    $('body').removeClass("Product_retailers_drawer_open_new");
    $(".Product_retailers_drawer_overlay_new").removeClass("open");
    $(".Product_retailers_drawer_maindetail_new").removeClass("open");
  })

  /* Nutrition Popup */
  $(".Product_meta_accordions_innerpopup_new").click(function () {
    $('body').addClass("overflow-hidden");
    $('body').addClass("Product_meta_accordions_open_new");
    $(".Product_information_meta_accordions_overlay_new").addClass("open");
    $(".Product_information_meta_accordions_mainpopup_new").addClass("open");
  })
  $(".Product_information_meta_accordions_overlay_new, .Product_information_meta_accordions_innerpopup_mainclose_new").click(function () {
    $('body').removeClass("overflow-hidden");
    $('body').removeClass("Product_meta_accordions_open_new");
    $(".Product_information_meta_accordions_overlay_new").removeClass("open");
    $(".Product_information_meta_accordions_mainpopup_new").removeClass("open");
  })

  if($(".Product_information_new").length > 0)
  {
    var stickyHeaderTopSticky = $(".Product_information_new").offset().top +  $(".Product_information_new").outerHeight(true) - $(".header").outerHeight(true);
    $(window).scroll(function(){
    
      if( $(window).scrollTop() > stickyHeaderTopSticky ) {
          if($('body').hasClass("sticky_header_new") == false)
          {
              $('body').addClass("hide_atc_button_new");
              setTimeout(function(){
                $('body').addClass("delay_sticky_header_new");
              }, 100);
              setTimeout(function(){
                $('body').addClass('sticky_header_new');
              }, 400);
          }
      } else {
          if ($('body').hasClass("sticky_header_new")) {
            $('body').removeClass("sticky_header_new");
            setTimeout(function(){
              $('body').removeClass("hide_atc_button_new");
              $("body").removeClass("delay_sticky_header_new");  
            }, 400);
          }
      }
    });
  }

}
productPageScript()

/*const emailInput = document.querySelector('.email-signup__input');
emailInput.addEventListener('input', () => {
  if (emailInput.value.trim() !== '') {
    emailInput.classList.add('typing');
  } else {
    emailInput.classList.remove('typing');
  }
});*/

const emailInputs = document.querySelectorAll('.contact-form__input');
emailInputs.forEach(emailBox => {
  emailBox.addEventListener('input', () => {
    if (emailBox.value.trim() !== '') {
      emailBox.classList.add('typing');
    } else {
      emailBox.classList.remove('typing');
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // Replace this with your actual Klaviyo form ID
  const formSelector = "[data-testid=POPUP]";

  // Watch for Klaviyo form to be added to DOM
  const observer = new MutationObserver(() => {
    const form = document.querySelector(formSelector);
    if (form) {
      const emailInput = form.querySelector('input[type="email"]');
      if (emailInput) {
        emailInput.addEventListener("input", function () {
          this.classList.toggle("typing", this.value.trim() !== "");
        });
        observer.disconnect(); // Stop watching once done
      }
    }
  });

  // Start observing the body for form injection
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
  // Replace this with your actual Klaviyo form ID
  const formSelector = ".Footer_innersides_innerright_innerforms_new";

  // Watch for Klaviyo form to be added to DOM
  const observer = new MutationObserver(() => {
    const form = document.querySelector(formSelector);
    if (form) {
      const emailInput = form.querySelector('input[type="email"]');
      if (emailInput) {
        emailInput.addEventListener("input", function () {
          this.classList.toggle("typing", this.value.trim() !== "");
        });
        observer.disconnect(); // Stop watching once done
      }
    }
  });

  // Start observing the body for form injection
  observer.observe(document.body, { childList: true, subtree: true });
});

$(".open_ketch_popup").click(function(e) {
  e.preventDefault();  // Prevent default anchor or button action
  e.stopPropagation(); // Stop event bubbling (optional, but safe)
  
  ketch('showExperience');
});


/* Header_announcement_bar_slider */
new Swiper('.Header_announcement_bar_slider', {
  loop: true,
  grabCursor: true,
  spaceBetween: 0,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  effect: "fade",
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }
})


/* Index_custom_slideshows_slider */
new Swiper('.Index_custom_slideshows_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 0,
  slidesPerGroup: 1,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  effect: "fade",
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
  }
})


/* Index_object_review_logos_slider */
new Swiper('.Index_object_review_logos_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  centeredSlides: true,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 20,
      slidesPerView: 1,
    },
    750: {
      slidesPerView: "auto"
    },
    990: {
    },
    1200: {
    },
    1440: {
    }
  }
})


/* megamenu_media_with_text_slider */
new Swiper('.megamenu_media_with_text_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: 5,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})


/* megamenu_media_with_text_detail_list_slider */
new Swiper('.megamenu_media_with_text_detail_list_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: 4,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})


/* Index_tab_feature_collect_list_slider */
new Swiper('.Index_tab_feature_collect_list_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 24,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      freeMode: !1,
      spaceBetween: 16,
    },
    750: {
      spaceBetween: 24
    },
    990: {
    },
    1200: {
    },
    1440: {
    }
  }
})


/* Index_tab_feature_collect_item_slider */
new Swiper('.Index_tab_feature_collect_item_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      freeMode: !1,
      spaceBetween: 24,
    },
    750: {
      spaceBetween: 16
    },
    990: {
    },
    1200: {
    },
    1440: {
    }
  }
})


/* Collection_custom_details_slider */
new Swiper('.Collection_custom_details_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 26,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  breakpoints: {
    0: {
      freeMode: !1,
      spaceBetween: 8,
    },
    750: {
      spaceBetween: 16
    },
    990: {
      spaceBetween: 26
    },
    1200: {
    },
    1440: {
    }
  }
})

/* accordion_ingredients_image_slider */
new Swiper('.accordion_ingredients_image_slider', {
  loop: true,
  grabCursor: true,
  spaceBetween: 0,
  slidesPerGroup: 1,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  observer: true,
  observeParents: true,
  effect: "fade"
})

/* Collection grid swapping without reload */
const ensureProductCardReviewParentheses = (scope) => {
  const context = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
  const elements = Array.from(context.querySelectorAll('.Product_card_content_mainreview_new .jdgm-prev-badge__text'));

  if (context !== document && typeof context.matches === 'function' && context.matches('.Product_card_content_mainreview_new .jdgm-prev-badge__text')) {
    elements.push(context);
  }

  elements.forEach((textEl) => {
    const original = textEl.textContent;

    if (!original) {
      return;
    }

    const trimmed = original.trim();

    if (!trimmed) {
      return;
    }

    const leadingWhitespaceMatch = original.match(/^\s*/);
    const trailingWhitespaceMatch = original.match(/\s*$/);
    const leadingWhitespace = leadingWhitespaceMatch ? leadingWhitespaceMatch[0] : '';
    const trailingWhitespace = trailingWhitespaceMatch ? trailingWhitespaceMatch[0] : '';
    const parentBadge = textEl.closest('.jdgm-prev-badge');
    const reviewCount = parentBadge && parentBadge.getAttribute('data-number-of-reviews');

    const cleanedCore = trimmed.replace(/^\(+/, '').replace(/\)+$/, '');

    if (reviewCount === '0') {
      if (trimmed.startsWith('(') || trimmed.endsWith(')')) {
        textEl.textContent = leadingWhitespace + cleanedCore + trailingWhitespace;
      }
      return;
    }

    if (!trimmed.startsWith('(')) {
      textEl.textContent = leadingWhitespace + '(' + cleanedCore + trailingWhitespace;
    }
  });
};

let productCardReviewParenthesesObserverStarted = false;

const initProductCardReviewParenthesesObserver = () => {
  if (productCardReviewParenthesesObserverStarted || typeof MutationObserver !== 'function') {
    return;
  }

  const startObserver = () => {
    if (productCardReviewParenthesesObserverStarted || !document.body) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node && typeof node.querySelectorAll === 'function') {
              ensureProductCardReviewParentheses(node);
            }
          });
        } else if (mutation.type === 'characterData') {
          const parent = mutation.target && mutation.target.parentElement;
          if (parent && typeof parent.querySelectorAll === 'function') {
            ensureProductCardReviewParentheses(parent);
          }
        }
      });
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });

    productCardReviewParenthesesObserverStarted = true;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
};

const runProductCardReviewParenthesesFix = () => {
  ensureProductCardReviewParentheses();
  initProductCardReviewParenthesesObserver();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runProductCardReviewParenthesesFix, { once: true });
} else {
  runProductCardReviewParenthesesFix();
}

/* Collection grid swapping without reload */
;
(function () {
  const buttonSelector = '.Collection_custom_details_button';

  const getResultsList = () => document.querySelector('results-list[section-id]');

  const requestSectionHTML = async (targetUrl, sectionId) => {
    const baseUrl = new URL(targetUrl, window.location.origin);
    baseUrl.searchParams.set('section_id', sectionId);

    const commonOptions = {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    };

    let response = await fetch(baseUrl.toString(), commonOptions);

    if (response.ok) {
      return response.text();
    }

    baseUrl.searchParams.delete('section_id');
    baseUrl.searchParams.set('sections', sectionId);

    response = await fetch(baseUrl.toString(), commonOptions);
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    const sectionJSON = await response.json();
    if (sectionJSON && sectionJSON[sectionId]) {
      return sectionJSON[sectionId];
    }

    throw new Error('Section response did not include expected HTML');
  };

  const fetchAndSwapCollection = async (trigger, resultsList) => {
    const targetUrl = trigger.dataset.collectionUrl || trigger.getAttribute('href');
    if (!targetUrl) {
      return;
    }

    const sectionId = resultsList && resultsList.getAttribute('section-id');

    if (!resultsList || !sectionId) {
      return;
    }

    if (trigger.classList.contains('is-loading')) {
      return;
    }

    trigger.classList.add('is-loading');
    resultsList.setAttribute('aria-busy', 'true');

    try {
      const html = await requestSectionHTML(targetUrl, sectionId);
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const incomingSection =
        doc.querySelector(`results-list[section-id="${sectionId}"]`) ||
        doc.querySelector('results-list');

      if (!incomingSection) {
        throw new Error('Unable to locate results-list in response');
      }

      incomingSection.setAttribute('aria-busy', 'false');
      resultsList.replaceWith(incomingSection);
      ensureProductCardReviewParentheses(incomingSection);
      initProductCardReviewParenthesesObserver();

      document.querySelectorAll(buttonSelector).forEach((button) => {
        button.classList.remove('active');
        button.classList.remove('is-loading');
      });
      trigger.classList.add('active');

      // incomingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.pushState({}, '', targetUrl);
    } catch (error) {
      console.error('Collection swap failed', error);
    } finally {
      const refreshedResultsList = getResultsList();
      if (refreshedResultsList) {
        refreshedResultsList.removeAttribute('aria-busy');
      }
      trigger.classList.remove('is-loading');
    }
  };

  const handleClick = (event) => {
    const trigger = event.target.closest(buttonSelector);
    if (!trigger) {
      return;
    }
    if (typeof fetch !== 'function') {
      return;
    }
    const resultsList = getResultsList();
    if (!resultsList) {
      return;
    }
    event.preventDefault();
    fetchAndSwapCollection(trigger, resultsList);
  };

    // document.addEventListener('click', handleClick, { passive: false });

    document.querySelectorAll(".Collection_custom_details_button").forEach(btn => {
      btn.addEventListener("click", function(event) {
        handleClick(event);
      })  
    });
  
})();